import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import sortIcon from '../../../icons/inspection-icons/sort.svg';
import sortActiveIcon from '../../../icons/inspection-icons/sort-active.svg';
import { renderInfoForType } from '../../../utils/helpers';
import styles from '../../../styles/general.module.scss';

const Table = ({ data, url }) => {
  const [tableData, setTableData] = useState([]);
  const [activeSortColumn, setActiveSortColumn] = useState('');
  const defaultOrderType = {
    inspection: 'asc',
    inspection_issue: 'asc',
    inspected_by: 'asc',
    start_date: 'asc',
    weather_conditions: 'asc'
  };
  const [orderType, setOrderType] = useState(defaultOrderType);

  useEffect(() => {
    const inspectionList = data.map(inspection => ({
      ...inspection,
      weather_conditions: inspection.weather_conditions?.title,
      start_date: renderInfoForType({ type: 'date' }, inspection.start_date, null, null),
      inspected_by: inspection.inspected_by?.fullname
    }));
    setTableData(inspectionList);
  }, [data]);

  const rowFun = inspection => (
    <tr key={inspection.id}>
      <td className="text-break" style={{ fontWeight: '700' }}>{inspection.inspection}</td>
      <td className="text-break" style={{ textAlign: 'center', fontSize: '22px', color: 'navy' }}>{inspection.issues}</td>
      <td className="text-break">{inspection.inspected_by}</td>
      <td className="text-break">{inspection.start_date}</td>
      <td className="text-break">{inspection.weather_conditions}</td>
      <td className="text-break" style={{ textAlign: 'center' }}>
        <Link to={`${url}/${inspection.id}/detail`}>
          <FormattedMessage
            id="inspections.list.table.view"
            defaultMessage="View"
          />
        </Link>
      </td>
    </tr>
  );

  const handleSortColumn = (field, order) => {
    let sortData = [];
    if (field === 'start_date') {
      sortData = _.orderBy(tableData, [row => row[field]], [order]);
    } else {
      sortData = _.orderBy(
        tableData,
        [row => (row[field] ? row[field].toLowerCase() : '')],
        [order]
      );
    }
    setOrderType({
      ...order,
      [field]: order === 'asc' ? 'desc' : 'asc'
    });
    setActiveSortColumn(field);
    setTableData(sortData);
  };

  return (
    <table className={`${styles.table} ${styles.evenWidth}`} cellSpacing="0">
      <thead>
        <tr>
          <th width="300">
            <FormattedMessage
              id="inspections.step2.type_inspection"
              defaultMessage="Type Of Inspection"
            />
            <button
             style={{ background: 'transparent', border: 'none', outline: 'none' }}
             onClick={() => {
                handleSortColumn('inspection', orderType.inspection);
              }}
             onKeyDown={() => {
                handleSortColumn('inspection', orderType.inspection);
             }}>
              <img
                src={
                  activeSortColumn === 'inspection' ? sortActiveIcon : sortIcon
                }
                alt=""
              />
            </button>
          </th>
          <th width="250">
            <FormattedMessage
              id="inspections.list.table.inspection_issue"
              defaultMessage="UNSATISFACTORY"
            />
            <button
             style={{ background: 'transparent', border: 'none', outline: 'none' }}
             onClick={() => {
                handleSortColumn('inspection_issue', orderType.inspection_issue);
              }}
             onKeyDown={() => {
                handleSortColumn('inspection_issue', orderType.inspection_issue);
             }}>
              <img
                src={
                  activeSortColumn === 'inspection_issue' ? sortActiveIcon : sortIcon
                }
                alt=""
              />
            </button>
          </th>
          <th width="250">
            <FormattedMessage
              id="inspections.list.table.inspected_by"
              defaultMessage="Inspected By"
            />
            <button
             style={{ background: 'transparent', border: 'none', outline: 'none' }}
             onClick={() => {
                handleSortColumn('inspected_by', orderType.inspected_by);
              }}
             onKeyDown={() => {
                handleSortColumn('inspected_by', orderType.inspected_by);
             }}>
              <img
                src={
                  activeSortColumn === 'inspected_by' ? sortActiveIcon : sortIcon
                }
                alt=""
              />
            </button>
          </th>
          <th width="200">
            <FormattedMessage
              id="forms.savedraft.date"
              defaultMessage="DATE"
            />
            <button
             style={{ background: 'transparent', border: 'none', outline: 'none' }}
             onClick={() => {
                handleSortColumn('start_date', orderType.start_date);
              }}
             onKeyDown={() => {
                handleSortColumn('start_date', orderType.start_date);
             }}>
              <img
                src={
                  activeSortColumn === 'start_date' ? sortActiveIcon : sortIcon
                }
                alt=""
              />
            </button>
          </th>
          <th width="270">
            <FormattedMessage
              id="wildlife.form.weather"
              defaultMessage="Weather Conditions"
            />
            <button
             style={{ background: 'transparent', border: 'none', outline: 'none' }}
             onClick={() => {
                handleSortColumn('weather_conditions', orderType.weather_conditions);
              }}
            onKeyDown={() => {
              handleSortColumn('weather_conditions', orderType.weather_conditions);
            }}>
              <img
                src={
                  activeSortColumn === 'weather_conditions' ? sortActiveIcon : sortIcon
                }
                alt=""
              />
            </button>
          </th>
          <th>
            <FormattedMessage
              id="wildlifelog.list.action"
              defaultMessage="Actions"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {tableData?.map(inspection => (
          <>
            {rowFun(inspection)}
          </>
        ))}
      </tbody>
      {tableData?.length === 0 && (
      <tbody>
        <tr>
          <td colSpan={6}>
            <FormattedMessage
              id="forms.list.table.no_results"
              defaultMessage="There are no inspections on the selected range"
            />
          </td>
        </tr>
      </tbody>
      )}
    </table>);
};

export default Table;
